// extracted by mini-css-extract-plugin
export const container = "cards-centred-module--container--3l-fs";
export const card = "cards-centred-module--card--1k63V";